import React from "react";
import { isDesktopDevice } from "../utils/deviceDetector";
import "./DesktopWarning.css";

const DesktopWarning = () => {
  if (!isDesktopDevice()) {
    return null;
  }

  return (
    <div className="desktop-warning-overlay">
      <div className="desktop-warning-content">
        <div className="desktop-warning-icon">📱</div>
        <h2>スマホでご利用ください</h2>
        <p>このアプリはスマートフォンでの利用を推奨しています</p>
        <div className="desktop-warning-instructions">
          <p>スマートフォンのブラウザで以下のURLを開いてください：</p>
          <code className="desktop-warning-url">{window.location.href}</code>
        </div>
        <div className="desktop-warning-qr">
          <p>またはQRコードをスキャン：</p>
          <div className="qr-placeholder">
            <img
              src="/QR_code.png"
              alt="QRコード"
              style={{ width: "150px", height: "150px" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesktopWarning;
